import Logo from '../common/Logo';
import { Outlet } from 'react-router-dom';

function PublicLayout() {
  return (
    <div className={`flex flex-col justify-center h-screen`}>
      <Logo />
      <Outlet />
    </div>
  );
}

export default PublicLayout;
